import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import StockorderproductEditFormImpl from 'components/stockorderproduct/StockorderproductEditFormImpl';
export default function ManageStockProductActionImpl(){

    return (
        <>
        <StockorderproductEditFormImpl/>
        </>
    )
}